import React from 'react';
import {Button, Grid, Typography} from "@material-ui/core";
import {useActions} from "../../actions";
import * as ClientActions from "../../actions/client";
import {isDebug} from "../../utils/commonUtils";


type VRCProps = { onViewIllustrationRequest: any; refreshPage: any; setViewIllustrationRequest: any | Function; };

const VRC: React.FC<VRCProps> = ({onViewIllustrationRequest, refreshPage, setViewIllustrationRequest}) => {
    const clientsAction = useActions(ClientActions);

    const onClose = () => {
        setViewIllustrationRequest(false);
        return refreshPage();
    };
    const onAck = async () => {
        await clientsAction.onAcknowledgeIllustrationRequest(onViewIllustrationRequest.id);
        // call api; set action item status 1
        return onClose()
    };
    return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography align="left" className="f18" variant='body1'>
                        {onViewIllustrationRequest.actionMessage}
                    </Typography>
                    {
                        isDebug() &&
                        <pre>{JSON.stringify({onViewIllustrationRequest}, null, 2)}</pre>
                    }
                    <Button
                            className="floatRight mt20 mb20"
                            color="primary"
                            onClick={onAck}
                            type="button"
                            variant="contained"
                    >
                        Acknowledge
                    </Button>
                    <Button
                            className="floatRight mr15 mt20 mb20"
                            color="secondary"
                            onClick={onClose}
                            type="button"
                            variant="contained"
                    >
                        Close
                    </Button>
                </Grid>
            </Grid>
    );
};

export default VRC;
